import { ApiForm } from '../../../../containers/apiForm';
import { useWebsiteInfo } from '../useWebsiteInfo';
import { url } from '../../../../constants/api';

export const AddPageForm = () => {
  const { websiteInfo, websiteId } = useWebsiteInfo();
  const pageTemplates = websiteInfo?.pageTemplates;
  const options = Object.keys(pageTemplates).map((template) => ({
    value: pageTemplates[template].component,
    label: pageTemplates[template].title || template,
  }));
  return (
    <ApiForm
      apiUrl={url(`website-configurations/${websiteId}/create-page`)}
      apiConfig={{ method: 'PATCH' }}
      elements={[
        {
          type: 'text',
          name: 'title',
          label: 'Page title',
          required: true,
        },
        {
          type: 'select',
          name: 'template',
          label: 'Page Templates',
          data: options,
          required: true,
        },
      ]}
      submitButtonProps={{
        children: 'Create',
      }}
    />
  );
};
